import React from 'react';
import { ViewMode, Worker } from '@react-pdf-viewer/core';
import { Viewer, SpecialZoomLevel, ScrollMode } from '@react-pdf-viewer/core';
import { zoomPlugin } from '@react-pdf-viewer/zoom';

export interface AppPdfViewerProps {
  pdf: string
};

const AppPdfViewer: React.FunctionComponent<AppPdfViewerProps> = ({pdf}) => {
  const zoomPluginInstance = zoomPlugin()
  const { ZoomInButton, ZoomOutButton, ZoomPopover } = zoomPluginInstance

  return (
    <div className="rpv-core__viewer" style={{ display: "flex", flexDirection: "column", height: "100%", border: "1px solid #E4E6EF", borderRadius: "5px" }}>
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: '#E4E6EF', padding: "2px 0px" }}>
        <ZoomOutButton />
        <ZoomPopover />
        <ZoomInButton />
      </div>
      <div style={{ flex: 1, overflow: "hidden", borderRadius: "5px" }}>
        <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
          <Viewer fileUrl={pdf} defaultScale={SpecialZoomLevel.PageWidth} viewMode={ViewMode.SinglePage} scrollMode={ScrollMode.Vertical} plugins={[zoomPluginInstance]} />
        </Worker>
      </div>
    </div>
  )
};

export default AppPdfViewer;
